class InfiniteScrollPagination extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.nextUrl = this.dataset.nextUrl;
    this.grid = document.getElementById('product-grid');
    this.loading = false;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && this.nextUrl && !this.loading) {
          this.loadNextPage();
        }
      },
      // Generous buffer so loading starts well before the trigger element
      // reaches the viewport — a single fast scroll fling can otherwise
      // jump past a smaller margin without the observer ever reporting
      // an intersection, silently stalling pagination.
      { rootMargin: '4000px 0px 0px 0px' },
    );
    this.observer.observe(this);

    // Belt-and-suspenders fallback: on very fast/large scroll jumps some
    // browsers can skip delivering an intersection change entirely. Re-check
    // proximity directly on scroll so pagination can't get stuck.
    this.boundScrollCheck = this.scrollCheck.bind(this);
    window.addEventListener('scroll', this.boundScrollCheck, { passive: true });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('scroll', this.boundScrollCheck);
  }

  scrollCheck() {
    if (!this.nextUrl || this.loading) return;
    const rect = this.getBoundingClientRect();
    if (rect.top < window.innerHeight + 4000) {
      this.loadNextPage();
    }
  }

  async loadNextPage() {
    this.loading = true;
    this.classList.add('loading');

    try {
      const separator = this.nextUrl.includes('?') ? '&' : '?';
      const url = `${this.nextUrl}${separator}section_id=${this.sectionId}`;
      const response = await fetch(url);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newItems = doc.getElementById('product-grid');
      if (newItems && this.grid) {
        Array.from(newItems.children).forEach((item) => {
          this.grid.appendChild(item);
        });
      }

      const newPager = doc.querySelector('infinite-scroll-pagination');
      this.nextUrl = newPager ? newPager.dataset.nextUrl : '';

      if (!this.nextUrl) {
        this.observer.disconnect();
        this.remove();
        document.dispatchEvent(new CustomEvent('catalog:all-products-loaded'));
      }
    } catch (error) {
      this.observer.disconnect();
      document.dispatchEvent(new CustomEvent('catalog:all-products-loaded'));
    } finally {
      this.loading = false;
      this.classList.remove('loading');
    }
  }
}

customElements.define('infinite-scroll-pagination', InfiniteScrollPagination);
